import { Component, ElementRef, HostListener, Input, OnInit, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-dropdown-select',
  templateUrl: './dropdown-select.component.html',
  styleUrls: ['./dropdown-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DropdownSelectComponent),
    multi: true
  }]
})
export class DropdownSelectComponent implements OnInit, ControlValueAccessor {
  
  @Input() dropdownValues: any[] = [];
  @Input() placeHolder: string = '-- select an option --';
  value: any = '';
  dropdownVisible: boolean = false;

  onTouched: () => void = () => {};
  onChange: (value: any) => void = () => {};

  constructor(private elementRef: ElementRef) { }

  ngOnInit() {}

  onFocus() {
    if (this.value === '') {
      this.dropdownVisible = true;
    }
  }

  onInput() {
    if (this.value === '') {
      this.dropdownVisible = true;
    } else {
      this.dropdownVisible = false;
    }
    this.onChange(this.value);
  }

  selectItem(item: any) {
    this.value = item.name;
    this.onChange(this.value);
    this.dropdownVisible = false;
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Implement if needed
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    if (!this.elementRef.nativeElement.contains(targetElement)) {
      this.dropdownVisible = false;
    }
  }
}
